<!-- Header -->
<h3 mat-dialog-title>
	Groups
</h3>

<!-- Body -->
<mat-dialog-content translate>
	Rows with the same group letter are joined with AND.
	<br />
	<br />
	Rows with different group letters are joined with OR.
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions>
	<div class='flex-footer-right'>
		<tyl-button image="Cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
	</div>
</mat-dialog-actions>